const LOCAL_DEV_API_URL = 'http://localhost:5002';
const DEFAULT_CD_API_URL = 'https://coolcare.cd';
const DEFAULT_ZM_API_URL = 'https://coolcare.co.zm';

const isLoopbackApiUrl = (url: string) => /localhost|127\.0\.0\.1/i.test(url);

const isLocalFrontendHost = (hostname: string) =>
  hostname === 'localhost' || hostname === '127.0.0.1';

const getDefaultProductionApiUrl = (hostname: string) => {
  const normalizedHostname = hostname.toLowerCase();

  if (normalizedHostname.endsWith('coolcare.co.zm')) {
    return DEFAULT_ZM_API_URL;
  }

  return DEFAULT_CD_API_URL;
};

/**
 * Resolves the brochure/contact mail API base URL.
 * Production sites must never call localhost (browser blocks loopback from public HTTPS).
 */
export function getBrochureApiUrl(): string {
  const configuredUrl = process.env.REACT_APP_BROCHURE_API_URL?.trim();

  if (typeof window === 'undefined') {
    if (configuredUrl && !isLoopbackApiUrl(configuredUrl)) {
      return configuredUrl;
    }
    return DEFAULT_CD_API_URL;
  }

  const hostname = window.location.hostname.toLowerCase();

  if (isLocalFrontendHost(hostname)) {
    return configuredUrl || LOCAL_DEV_API_URL;
  }

  if (configuredUrl && !isLoopbackApiUrl(configuredUrl)) {
    return configuredUrl;
  }

  return getDefaultProductionApiUrl(hostname);
}